import Table from "../types/Table";

const isSearchConsoleEnabled = (table: Table) => {
    return table.enable_search_console && table.search_console_settings !== null
}

export default isSearchConsoleEnabled;